import styled from 'styled-components';

export const DialogContainer = styled.section`
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(50, 51, 56, 0.35);
  z-index: 10000;
  top: 0;
  left: 0;
`;

export const DialogView = styled.dialog`
  width: ${({ width }) => width || '50%'};
  min-width: 500px;
  z-index: 1;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  padding: 0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 768px) {
    width: 100%;
    top: 0;
    left: 0;
    transform: unset;
    bottom: 66px;
    right: 0;
    max-height: 100%;
    overflow-y: auto;
    border-radius: 0;
  }

  .close__icon {
    cursor: pointer;
    padding: 4px;
    margin-left: auto;
  }
`;
